module.exports = __webpack_public_path__ + "img/syl_gallery7.33e6c840.jpg";